// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Show it is fixed to the top */

.app-header-image {
	max-height: 48px;
}

.app-header-image-mobile {
	max-width: 300px;
}

@media only screen and (max-width: 400px) {
	.app-header-image-mobile {
		max-width: 200px;
	}
}

/*
@media only screen and (max-width: 600px) {
	.app-header-image {
		max-width: 80px;
	}
}
*/

main {
	flex: 1;
	margin-top: 84px;
}

.footer-link {
  font-family: 'Oxygen', sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  color: #6c757d;
  text-decoration: none;
  white-space: nowrap;
}

.footer-link:hover {
  color: #212529;
  text-decoration: underline;
}

.footer-version {
  font-family: 'Oxygen', sans-serif;
  font-size: 0.75rem;
  color: #adb5bd;
  font-style: italic;
  white-space: nowrap;
}

@media (max-width: 400px) {
    .app-logo {
      width: 240px;
    }
}

.ng-valid[required], .ng-valid.required  {
  border-bottom: 2px solid #42A948; /* green */
}

.ng-invalid:not(form)  {
  border-bottom: 2px solid #a94442; /* red */
}
/* ── Adopted-identity banner (admin ADOPT IDENTITY sessions only) ───────────── */
.adopted-session-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1080;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  background: #7a2e2e;
  color: #fff;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);
}

.adopted-session-text {
  flex: 1 1 auto;
  min-width: 0;
}

.adopted-session-exit {
  flex: 0 0 auto;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
}
`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;;;;;;CAMC;;AAED;CACC,OAAO;CACP,gBAAgB;AACjB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;IACI;MACE,YAAY;IACd;AACJ;;AAEA;EACE,gCAAgC,EAAE,UAAU;AAC9C;;AAEA;EACE,gCAAgC,EAAE,QAAQ;AAC5C;AACA,kFAAkF;AAClF;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":["/* Show it is fixed to the top */\n\n.app-header-image {\n\tmax-height: 48px;\n}\n\n.app-header-image-mobile {\n\tmax-width: 300px;\n}\n\n@media only screen and (max-width: 400px) {\n\t.app-header-image-mobile {\n\t\tmax-width: 200px;\n\t}\n}\n\n/*\n@media only screen and (max-width: 600px) {\n\t.app-header-image {\n\t\tmax-width: 80px;\n\t}\n}\n*/\n\nmain {\n\tflex: 1;\n\tmargin-top: 84px;\n}\n\n.footer-link {\n  font-family: 'Oxygen', sans-serif;\n  font-size: 0.8rem;\n  font-weight: 400;\n  color: #6c757d;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.footer-link:hover {\n  color: #212529;\n  text-decoration: underline;\n}\n\n.footer-version {\n  font-family: 'Oxygen', sans-serif;\n  font-size: 0.75rem;\n  color: #adb5bd;\n  font-style: italic;\n  white-space: nowrap;\n}\n\n@media (max-width: 400px) {\n    .app-logo {\n      width: 240px;\n    }\n}\n\n.ng-valid[required], .ng-valid.required  {\n  border-bottom: 2px solid #42A948; /* green */\n}\n\n.ng-invalid:not(form)  {\n  border-bottom: 2px solid #a94442; /* red */\n}\n/* ── Adopted-identity banner (admin ADOPT IDENTITY sessions only) ───────────── */\n.adopted-session-bar {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1080;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.5rem 1rem;\n  background: #7a2e2e;\n  color: #fff;\n  font-size: 0.85rem;\n  letter-spacing: 0.03em;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.25);\n}\n\n.adopted-session-text {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.adopted-session-exit {\n  flex: 0 0 auto;\n  font-size: 0.75rem;\n  letter-spacing: 0.05em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
